import styled from 'styled-components';
import { color, fontSize, fontWeight, spacing } from '../../theme';

export const StyledRole = styled.div`
  dt {
    border-top: 1px solid ${color('midnight_200')};
  }
`;

export const StyledTrigger = styled.button`
  padding: ${spacing('md')} 0;
  background-color: unset;
  border: unset;
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing('md')};
  cursor: pointer;
  color: ${'midnight_800'};
  -webkit-appearance: none;

  h3 {
    margin: 0;
    font-family: inherit;
    font-size: ${fontSize('md')};
    line-height: 1.25;
    font-weight: ${fontWeight('black')};
  }

  &.is-active {
    svg {
      transform: rotate(180deg);
    }
  }

  &:hover {
    transition: 0.3s;
    h3 {
      color: ${color('text_subtle')};
    }
  }
  &:focus-visible {
    outline: ${spacing('xs2')} solid ${color('midnight_150')};
    outline-offset: 2px;
  }
`;

export const StyledContent = styled.dd`
  overflow: hidden;
  margin: 0;
  max-height: 0;
  //transition: max-height 0.3s ease-in-out;

  &.is-active {
    max-height: var(--subcontent-height);
    border-top: 1px solid ${color('midnight_200')};
  }

  div {
    padding: ${spacing('md')} 0;
  }

  ul,
  ol {
    padding-left: ${spacing('md')};
  }
  li {
    list-style-type: disc;
  }

  ol li {
    list-style-type: decimal;
  }

  p {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
